import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("vexen_user");
    return u ? JSON.parse(u) : null;
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("vexen_token");
    if (!t) { setReady(true); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("vexen_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("vexen_token");
      localStorage.removeItem("vexen_user");
      setUser(null);
    }).finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vexen_token", data.token);
    localStorage.setItem("vexen_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("vexen_token");
    localStorage.removeItem("vexen_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
